import { useSyncExternalStore } from 'react'

export const useWindowFocus = () => {
  return useSyncExternalStore(
    cb => {
      const updateFocus = () => {
        cb()
      }

      updateFocus()

      window.addEventListener('focus', updateFocus)
      window.addEventListener('blur', updateFocus)

      return () => {
        window.removeEventListener('blur', updateFocus)
        window.removeEventListener('focus', updateFocus)
      }
    },
    () => document.hasFocus(),
    () => true
  )
}
